import { render, staticRenderFns } from "./MarketingPlan.vue?vue&type=template&id=5a3ef445&scoped=true&"
import script from "./MarketingPlan.vue?vue&type=script&lang=js&"
export * from "./MarketingPlan.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPlan.vue?vue&type=style&index=0&id=5a3ef445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ef445",
  null
  
)

export default component.exports